'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_f92dd299 = {"container":"Popover_module_container__520f807d","trigger-backdrop":"Popover_module_triggerBackdrop__520f807d","overlay":"Popover_module_overlay__520f807d","backdrop":"Popover_module_backdrop__520f807d","header":"Popover_module_header__520f807d","content":"Popover_module_content__520f807d","close":"Popover_module_close__520f807d"};
require("../../../assets/cjs/components/Popover/src/Popover~DmfiT90j.css");

exports.default = modules_f92dd299;
//# sourceMappingURL=Popover.module.less.js.map
